<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    div.py-6.px-10
      .text-lg.font-semibold.mb-2 Complete order confirmation
      template(v-if="isItemFullyReceived")
        .text-md.mb-2
          span.font-semibold All of your items have been received 
          span as per your requested requirements.
        .text-md Click “Complete order” to complete your order.
      template(v-else)
        .text-md.mb-2
          span.font-semibold You still have not receive some items 
          span that not meet your requested requirements.
        .text-md Are you sure you want to complete this order?
    v-divider
    v-card-actions.px-6
      v-spacer
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-btn.button-md(:loading="loading" depressed dark @click="handleCompleteOrder") Complete order
</template>
  
<script>
export default {
  props: {
    open: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedItem: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isItemFullyReceived () {
      return this.selectedItem?.inventoryStatus === 'fully_received'
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closed')
      this.showDialog = false
    },
    handleCompleteOrder () {
      this.$emit('confirmed')
    },
  },
}
</script>

<style scoped>
</style>